export const zeroPadding = (num: number, len: number): string => {
  return (Array(len).join('0') + num).slice(-len)
}
function toJST(date: Date): Date {
  // 日本標準時 (JST) は UTC+9
  const JST_OFFSET = 9 * 60; // 9時間を分に変換
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  const jstDate = new Date(utcDate.getTime() + JST_OFFSET * 60000);
  return jstDate;
}

export const dateDisplay = (date: Date | string): string => {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = toJST(new Date(date))
  }
  return `${date.getFullYear()}年${zeroPadding(date.getMonth() + 1, 2)}月${zeroPadding(
    date.getDate(),
    2,
  )}日`
}
export const dateDisplayWithTime = (date: Date | string): string => {
  console.log('date:', date);
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = toJST(new Date(date))
  }
  return `${date.getFullYear()}年${zeroPadding(date.getMonth() + 1, 2)}月${zeroPadding(
    date.getDate(),
    2,
  )}日 ${zeroPadding(date.getHours(), 2)}:${zeroPadding(date.getMinutes(), 2)}`
}
